// api.js
import axios from "axios";

import { auth } from "../firebase";

const API_BASE_URL = process.env.REACT_APP_API_URL;

// Tạo instance axios
const api = axios.create({
  baseURL: API_BASE_URL, // Thay đổi baseURL theo dự án của bạn
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 30000,
});

// Add request interceptor for authentication
api.interceptors.request.use(
  async (config) => {
    // Log API calls for debugging
    // console.log(`🔄 API Call: ${config.method?.toUpperCase()} ${config.url}`);

    // Get Firebase auth token if user is authenticated
    const user = auth.currentUser;
    if (user) {
      try {
        const idToken = await user.getIdToken();
        config.headers.Authorization = `Bearer ${idToken}`;
      } catch (error) {
        console.error("Error getting auth token:", error);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    // Log successful responses
    console.log(
      `✅ API Success: ${response.config.method?.toUpperCase()} ${
        response.config.url
      }`
    );
    return response;
  },
  (error) => {
    // Log API errors
    console.error(
      `❌ API Error: ${error.config?.method?.toUpperCase()} ${
        error.config?.url
      }`,
      error.response?.data || error.message
    );

    // Handle authentication errors
    if (error.response?.status === 401) {
      // Redirect to login if unauthorized
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);
export default api;
